import { render, staticRenderFns } from "./PodCasts.vue?vue&type=template&id=358d5531&scoped=true&"
import script from "./PodCasts.vue?vue&type=script&lang=js&"
export * from "./PodCasts.vue?vue&type=script&lang=js&"
import style0 from "./PodCasts.vue?vue&type=style&index=0&id=358d5531&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358d5531",
  null
  
)

export default component.exports